import FooterToolbar from '../footer-toolbar'

export default {
  name: 'Common',
  components: {
    FooterToolbar
  },
  data () {
    return {
      page: 1,
      total: 0,
      // 选择标签
      tags: [],
      // 标签设置时当前所选标签
      tagIdList: [],
      // 列表数据
      data: [],
      // 用于防抖
      inputTimer: null,
      // 图片搜索框
      name: '',
      // 文件类型下拉搜索
      fileType: '',
      // 内容是否正在加载
      isLoading: false,
      // 修改文件名的输入框值
      inputVal: '',
      // 用于比较是否需要修改
      currentVal: '',
      // 当前操作的资料的id
      currentId: '',
      // 是否显示【标签设置弹窗】
      isShowSetTagDialog: false,
      // 是否开启批量操作
      isBatch: false,
      // 是否全选
      selectAll: false,
      // 批量操作选中数据
      currentSelection: [],
      // 批量删除数组
      batchDeleteArr: [],
      // 批量删除确认弹窗
      dialogVisible: false
    }
  },
  created () {
    this.mbamaterialListPost()
  },
  methods: {
    showInput (data, index) {
      let { name, _id } = data
      this.inputVal = name
      this.currentVal = name
      this.currentId = _id
      this.data[index].inputVisible = true
      this.$nextTick(() => {
        this.$refs.changeNameInput[index].$children[0].focus()
      })
    },
    // 修改资料名
    async changeName (data, index) {
      if (!this.inputVal) {
        this.$message.error('保存失败，名称不能为空')
        this.data[index].inputVisible = false
        return
      }
      if (this.currentVal === this.inputVal) {
        this.data[index].inputVisible = false
        return
      }
      let params = {
        _id: this.currentId,
        name: this.inputVal,
        directory: data.directory,
        suffix: data.suffix
      }
      let res = await MKMATERIALSVC.MbamaterialApi.mbamaterialUpdatePost(params)
      if (res.success) {
        this.$message.success('保存成功')
        this.mbamaterialListPost()
      } else {
        this.$message.error('保存失败')
      }
      this.data[index].inputVisible = false
    },
    // 上传结束后
    onUploadFinish () {
      this.mbamaterialListPost()
    },
    onInput () {
      clearTimeout(this.inputTimer)
      this.inputTimer = setTimeout(() => {
        this.page = 1
        this.mbamaterialListPost()
      }, 300)
    },
    handleOnSearch () {
      this.page = 1
      this.mbamaterialListPost()
    },
    handleCurrentChange () {
      this.mbamaterialListPost()
    },
    // 获取资料列表
    async mbamaterialListPost () {
      this.isLoading = true
      let params = {
        type: this.type,
        name: this.name,
        page: this.page,
        pageSize: 10
      }
      // 视频
      if (this.type === 2) {
        params.suffix = this.suffix
      }
      // 文件参数处理，fileType默认为0
      if (this.type === 3) {
        params.fileType = this.fileType || 0
      }
      let res = await MKMATERIALSVC.MbamaterialApi.mbamaterialListPost(params)
      this.isLoading = false
      if (res.success) {
        let { data, page, total } = res.data
        data.forEach((item) => {
          // 推个批量操作的状态
          item.checked = false
          item.inputVisible = false
          // 视频
          if (this.type === 2) {
            item.isPlay = false
          }
        })
        this.data = data
        this.page = page
        this.total = total
        // 视频
        if (this.type === 2) {
          // 监听点击暂停
          this.$nextTick(() => {
            let videoList = document.querySelectorAll('video')
            videoList.forEach(item => {
              item.onpause = e => {
              // 延时来确定是否是进度条改变触发事件pause，若是进度条改变，则不应该暂停
                setTimeout(() => {
                  if (item.paused) {
                    let index = item.getAttribute('tarindex')
                    this.data[index].isPlay = false
                  }
                }, 200)
              }
            })
          })
        }
      }
    },
    // 删除资料
    async ordinaryDelete (_id) {
      this.dialogVisible = false
      let params = {
        type: this.type,
        ids: [_id]
      }
      if (this.isBatch) {
        params.fileArr = this.batchDeleteArr
      }
      let res = await MKMATERIALSVC.MbamaterialApi.mbamaterialDelete(params)
      if (res.success) {
        this.$message.success('删除成功')
        // 取消批量状态
        this.isBatch = false
        // 清空所选数组
        this.currentSelection = []
        // 全选置为否
        this.selectAll = false
        this.mbamaterialListPost()
      } else {
        this.$message.error('删除失败')
      }
    },
    // 点击上传
    uploadClick () {
      this.$refs.upload.upload()
    },
    // 下载文件
    downloadFile (data) {
      let a = document.createElement('a')
      const event = new MouseEvent('click')
      a.href = data.url
      // 合成函数，执行下载
      a.dispatchEvent(event)
      a = null
    },

    // 批量操作
    // 开始批量操作
    openBatchOp () {
      this.isBatch = true
    },
    // 文件的批量操作
    fileSelectItem (val) {
      this.currentSelection = val
      // 当文件挨个勾选至全选时，将底部全选状态变为 全选
      this.selectAll = this.currentSelection.length === this.data.length
    },
    // 批量操作时，每一项的遮罩，遮盖其余操作 点击改变选择状态
    selectItem (item) {
      // 批量操作时 选中/取消选中
      item.checked = !item.checked
      // 为true时推入选中数组，为false时 从选中数组删除
      if (item.checked) {
        this.currentSelection.push(item)
      } else {
        // 找到索引
        this.currentSelection.map((items, index) => {
          if (items.id === item.id) {
            this.currentSelection.splice(index, 1)
          }
        })
      }
      // 底部组件全选状态
      this.selectAll = this.currentSelection.length === this.data.length
    },
    // 文件 表格的全选操作
    fileHandleOnCheckedChange (val) {
      if (val.length === 0) {
        this.currentSelection = []
        this.selectAll = false
      } else {
        this.currentSelection = val
        this.selectAll = true
      }
    },
    // 底部操作栏全选操作
    handleOnCheckedChange (val) {
      // 文件的全选操作
      if (this.type === 3) {
        if (val) {
          // 触发表格本页全选事件
          this.$refs.tableList.toggleAllSelection()
        } else {
        // 取消全选事件
          this.$refs.tableList.clearSelection()
        }
      }
      this.currentSelection = []
      this.data.forEach((item) => {
        item.checked = val
        if (val) {
          this.currentSelection.push(item)
        }
      })
      this.selectAll = val
    },
    // 批量删除
    handleOnToolbarRemoveClick () {
      if (this.currentSelection.length > 0) this.dialogVisible = true
      else this.$message.error('请选择删除内容')
    },
    handleOnToolbarRemoveClickCenter () {
      let arr = []
      this.currentSelection.map(item => {
        arr.push({ id: item.id, directory: item.directory })
        return arr
      })
      this.batchDeleteArr = arr
      this.ordinaryDelete()
    },
    // 批量打标签
    handleOnToolbarApplyClick () {
      if (this.currentSelection.length !== 0) {
        // 清空当前标签数组，不进行回显
        this.tagIdList = []
        // 打开标签窗口
        this.isShowSetTagDialog = true
      } else {
        this.$message({
          type: 'error',
          message: '请选择资料'
        })
      }
    },
    // 取消批量操作
    handleOnToolbarCloseClick () {
      this.isBatch = false
      // 清空当前选中数组
      this.currentSelection = []
      this.data.forEach((item) => {
        // 将数据批量操作的状态初始化为空
        item.checked = false
      })
      // 文件表格选中单独处理
      if (this.type === 3) {
        this.$refs.tableList.clearSelection()
      }
      // 全选置为否
      this.selectAll = false
    }

  }
}
